import api from './ajax.js'
import config from './config.js'
// import { resolve } from 'path';

// function getMenu (url, callback) {
//   api.get(config.host + 'account/menu.do').then((data) => {
//     if (data.success) {
//       callback(data.body)
//       // this.getMenu(data.body)
//     }
//   })
// }

// 格式化成Map
function formatMap (data, key, childKey) {
  let cusMKeys
  if (childKey && childKey.length > 0) {
    cusMKeys = {
      data: {}, // 所有集合
      dataHC: [], // 有子项的集合
      get: function (key) {
        return this.data[key]
      },
      set: function (key, value) {
        let itemPro = this.get(key)
        if (itemPro === undefined) {
          this.data[key] = value
          if (this.data[key][childKey] && this.data[key][childKey] !== '0') {
            this.dataHC.push(value)
          }
        }
      },
      remove: function (key) { // 移除某项值
        if (data[key]) {
          delete data[key]
        }
      }
    }
  } else {
    cusMKeys = {
      data: [],
      get: function (key) {
        return this.data[key]
      },
      set: function (key, value) {
        if (this.get(key) === undefined) {
          this.data[key] = []
          this.data[key].push(value)
        } else {
          if (this.data[key] instanceof Array) {
            this.data[key].push(value)
          } else {
            var arr = []
            arr.push(this.get(key))
            arr.push(value)
            this.data[key] = arr
          }
        }
      }
    }
  }
  for (let i in data) {
    var item = data[i]
    cusMKeys.set(item[key], item)
  }

  return cusMKeys
}

function reorgMenu (url) {
  return new Promise(resolve => {
    api.get(config.host + url).then((res) => {
      if (res.success) {
        var data = res.body
        var menus = []
        // { 1.定义各子项的集合 }
        let modules = data.ModuleList // 接受模块的集合
        let functions = data.FunctionList // 接受功能的集合
        let operation = data.OperationList // 接受操作的集合

        // {2.遍历格式化接受的模块}
        let moduleMap = formatMap(modules, 'moduleID', 'parentModuleIDs')
        if (moduleMap.dataHC) {
          moduleMap.dataHC.forEach(item => {
            let ids = item.parentModuleIDs.split(',')
            item.childs = []
            ids.forEach(j => {
              if(moduleMap.data[j]){
                item.childs.push(moduleMap.data[j])
                delete moduleMap.data[j]
              }
            })
          })
          // for (let i in moduleMap.data) {
          //   menus.push(moduleMap.data[i])
          // }
        }
        // 获取第一级菜单有哪些
        let lvOne = []
        for (let i in moduleMap.data) {
          lvOne.push(parseInt(i))
        }
        // 将moudule导入菜单
        for (let i in modules) {
          if (lvOne.includes(modules[i].moduleID)) {
            menus.push(modules[i])
          }
        }
        // {3.遍历格式化接受的功能}
        // for (let i in functions) {
        //   // console.log(functions[i].url)
        //   if (functions[i].url.includes('reportKey=') || functions[i].url.includes('reports/defautreport.jsp')) {
        //     // console.log(functions[i].url)
        //   } else {
        //   }
        // }
        functions = formatMap(functions, 'moduleID')
        // {4.遍历格式化接受的操作}
        operation = formatMap(operation, 'funcID')

        // {5.循环组装模块/功能/报表}
        // 将操作与functions绑定
        for (let key in functions.data) {
          functions.data[key].forEach(i => {
            // console.log(i)
            if (i.url.includes('rpid=')) {
              i.url = config.host + i.url + '&rstatus=' + true + '&reportName=' + i.funcName
              i.funcTips = i.url
            } else if (i.url.includes('reportKey=')) {
              i.url = config.host + i.url + '&reportName=' + i.funcName
              i.funcTips = i.url
            } else {}
            let funcItemc = operation.get(i.funcID)
            if (funcItemc && funcItemc.length > 0) {
              i.operation = []
              i.operation = funcItemc
            }
          })
        }

        // 将functions与modules绑定
        menus.forEach(item => {
          if (item.childs && item.childs.length > 0) {
            item.childs.forEach(j => {
              // 存入functions到子module里面
              let funcItemc = functions.get(j.moduleID)
              if (funcItemc && funcItemc.length > 0) {
                j.childs = funcItemc
              }
            })
          } else {
            item.childs = []
            // 存入functions到module里面
            let funcItem = functions.get(item.moduleID)
            if (funcItem && funcItem.moduleID) {
              item.childs.push(funcItem)
            } else if (funcItem && funcItem.length > 0) {
              item.childs = funcItem
            }
          }
        })
        resolve(menus)
      }
    })
  })
}
export default reorgMenu



// WEBPACK FOOTER //
// ./src/com/menu.js